import { render, staticRenderFns } from "./CockpitManagement.vue?vue&type=template&id=187bb996"
import script from "./CockpitManagement.vue?vue&type=script&lang=js"
export * from "./CockpitManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports